import axios from "axios";

export const TOURNAMENT_ID = process.env.REACT_APP_TOURNAMENT_ID;

export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ??
  "https://middleware.bmw-golfsport-live.com";

export const leaderboard_url = `${API_BASE_URL}/use-leaderboard`;
export const player_url = () => `${API_BASE_URL}/use-player`;
export const players_url = `${API_BASE_URL}/use-players`;
export const news_url = (startAt: number | null) =>
  `${API_BASE_URL}/news/latest${startAt ? `?startAt=${startAt}` : ""}`;
export const hole_url = () => `${API_BASE_URL}/use-hole`;
export const course_url = `${API_BASE_URL}/use-course`;

let api = axios.create();

// add token als default
// saves setting token for every request in queries
api.defaults.params = {
  ...api.defaults.params,
  tournamentId: TOURNAMENT_ID,
};

api.defaults.auth = {
  ...api.defaults.auth,
  username: process.env.REACT_APP_AUTH_USERNAME ?? "",
  password: process.env.REACT_APP_AUTH_PASSWORD ?? "",
};

api.defaults.headers = {
  ...api.defaults.headers,
  "Content-Type": "application/json",
};

export default api;
